<div class="list-container">
    <div class="toolbar-container" style="display: flex; align-items: center; justify-content: right; padding-bottom: 10px;" *ngIf="canConfigure">
        <button (click)="addNewProfile()" mat-flat-button color="accent" style="display: flex; align-items: center; padding: 4px 16px; font-size: 12px; border-radius: 6px;">
            <!-- Plus rounded icon -->
            <svg style="display: inline-block; vertical-align: middle; width: 16px; height: 16px; margin-right: 8px;" width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd">
                    <path d="M24 0v24H0V0z"/>
                    <path d="M15 3.523a8.865 8.865 0 0 0-6 0M3.157 10.358a8.981 8.981 0 0 1 3-5.196M6.157 18.838a8.982 8.982 0 0 1-3-5.196M9 20.477c1.94.697 4.06.697 6 0M20.843 10.358a8.981 8.981 0 0 0-3-5.196M17.843 18.838a8.982 8.982 0 0 0 3-5.196M10 12h4M12 14v-4" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
            </svg>
            <span style="white-space: nowrap;">Add New</span>
        </button>
    </div>
    <div class="confirmation-banner error-banner" *ngIf="errorMessage">
        <mat-icon>error</mat-icon>
        <span>{{ errorMessage }}</span>
    </div>
    <div class="table-wrapper">
        <table mat-table [dataSource]="savedProfiles" class="profiles-table">

            <!-- Vulnerability Profile Type Column -->
            <ng-container matColumnDef="vulnerabilityType" sticky>
                <th mat-header-cell *matHeaderCellDef class="profile-type-header">
                    Vulnerability profile type
                </th>
                <td mat-cell *matCellDef="let profile" class="profile-type-cell">
                    {{ profile.vulnerabilityType }}
                </td>
            </ng-container>

            <!-- Dynamic Indicator Columns -->
            <ng-container *ngFor="let indicator of indicators" [matColumnDef]="indicator.code">
                <th mat-header-cell *matHeaderCellDef class="overlay-header">
                    <div class="overlay-header-content">
                        <div class="overlay-abbr">{{ indicator.code }}</div>
                        <div class="overlay-name">{{ indicator.name }}</div>
                    </div>
                </th>
                <td mat-cell *matCellDef="let profile" class="overlay-cell">
                    {{ profile[indicator.code] !== null ? profile[indicator.code] : '-' }}
                </td>
            </ng-container>

            <!-- Last Updated Column -->
            <ng-container matColumnDef="updatedOn">
                <th mat-header-cell *matHeaderCellDef class="updated-on-header">
                    Last Updated
                </th>
                <td mat-cell *matCellDef="let profile" class="updated-on-cell">
                    <span *ngIf="profile.updatedOn; else noUpdatedOn"
                          [matTooltip]="profile.updatedOn | date: 'dd MMM yyyy, HH:mm'">
                        {{ profile.updatedOn | date: 'dd MMM yyyy' }}
                    </span>
                    <ng-template #noUpdatedOn>-</ng-template>
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions" stickyEnd>
                <th mat-header-cell *matHeaderCellDef class="actions-header">
                    Actions
                </th>
                <td mat-cell *matCellDef="let profile" class="actions-cell">
                    <div class="actions-icons" *ngIf="canConfigure">
                        <svg class="clickable-icon" [class.disabled-icon]="isCalculationInProgress(profile)"
                            (click)="editProfile(profile)" width="15" height="15" viewBox="0 0 15 15" fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            [matTooltip]="isCalculationInProgress(profile) ? 'Calculation in progress' : 'Edit Profile'">
                            <path
                                d="M10.2969 3.38001L11.62 4.70314M11.1475 2.21439L7.56813 5.79376C7.38263 5.97804 7.2564 6.21352 7.20563 6.47001L6.875 8.12501L8.53 7.79376C8.78625 7.74251 9.02125 7.61689 9.20625 7.43189L12.7856 3.85251C12.8932 3.74495 12.9785 3.61726 13.0367 3.47672C13.0949 3.33619 13.1249 3.18557 13.1249 3.03345C13.1249 2.88134 13.0949 2.73071 13.0367 2.59018C12.9785 2.44964 12.8932 2.32195 12.7856 2.21439C12.6781 2.10683 12.5504 2.02151 12.4098 1.96329C12.2693 1.90508 12.1187 1.87512 11.9666 1.87512C11.8144 1.87512 11.6638 1.90508 11.5233 1.96329C11.3828 2.02151 11.2551 2.10683 11.1475 2.21439Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M11.875 9.375V11.25C11.875 11.5815 11.7433 11.8995 11.5089 12.1339C11.2745 12.3683 10.9565 12.5 10.625 12.5H3.75C3.41848 12.5 3.10054 12.3683 2.86612 12.1339C2.6317 11.8995 2.5 11.5815 2.5 11.25V4.375C2.5 4.04348 2.6317 3.72554 2.86612 3.49112C3.10054 3.2567 3.41848 3.125 3.75 3.125H5.625"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <svg class="clickable-icon" [class.disabled-icon]="!isDeletable(profile)"
                            (click)="deleteProfile(profile)" width="15" height="15"
                            viewBox="0 0 15 15" fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            [matTooltip]="deleteTooltip(profile)">
                            <path d="M2.5 4.375H12.5M5.625 4.375V3.125C5.625 2.79348 5.7567 2.47554 5.99112 2.24112C6.22554 2.0067 6.54348 1.875 6.875 1.875H8.125C8.45652 1.875 8.77446 2.0067 9.00888 2.24112C9.2433 2.47554 9.375 2.79348 9.375 3.125V4.375"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.25 4.375V11.875C11.25 12.2065 11.1183 12.5245 10.8839 12.7589C10.6495 12.9933 10.3315 13.125 10 13.125H5C4.66848 13.125 4.35054 12.9933 4.11612 12.7589C3.8817 12.5245 3.75 12.2065 3.75 11.875V4.375"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6.25 6.875V10.625M8.75 6.875V10.625"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </td>
            </ng-container>

            <!-- Header and Row Declarations -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- No Data Row -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
                    {{ isLoading ? 'Loading...' : 'No saved profiles found' }}
                </td>
            </tr>
        </table>
    </div>
</div>
